export default String.raw`
.products-page__main-container{
    margin: 30px;
    .left{
        display: none;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;
    }
    .categories-and-filters-container{
        width: 360px;
        height: 100%;
        background-color: $bgColor;
        overflow-y: auto;
    }
    .filters-menu-background{
        background-color: rgba(46, 46, 46, 0.20);
        position: fixed;
        top: 0;
        left: 360px;
        right: 0;
        bottom: 0;
        cursor: pointer;
    }
    .right{
        width: 100%;
    }
}

.categories-and-filters-header{
    display: flex;
    justify-content: space-between;
    background-color: $bgColor;
    padding: 15px;
    &__title{
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
    }
    svg{
        width: 24px;
        height: 24px;
        fill: #959595;
        cursor: pointer;
    }
}

.categories{
    border: none;
    &__title{
        padding-bottom: 15px;
        border-bottom: 1px solid #D5D5D5;
    }
}

.filters{
    border: none;
}

.sorting-and-views{
    &__filter-and-sorting{
        display: inline-flex;
        gap: 15px;
    }
    &__toggle-filters-menu{
        display: inline-flex;
        padding: 8px 24px;
        background: $inputsBgColor;
        svg{
            width: 15px;
            height: 15px;
            fill: $primaryColor;
        }
    }
}
`